import { AiChatConfigurationContext, AiChatFieldContext } from '@server/ai';

export enum CrmOrgPlatforms {
  Salesforce = 'salesforce',
}

export enum OrgType {
  Salesforce = 'salesforce',
  Snowflake = 'snowflake',
}

export interface CrmOrgCreateDto {
  name: string;
  platform: CrmOrgPlatforms;
  orgType?: OrgType;
  isMain?: boolean;
  isSandbox: boolean;
}

export interface CrmOrgPatchDto {
  name: string;
}

export interface CrmOrgGetUsersResponse {
  users: CrmOrgUser[];
}

export interface CrmOrgUsersBaseResponse {
  includeInactive: boolean;
  users: CrmOrgUserBase[];
}

export interface CrmOrgOAuthDto {
  crmOrgId: string;
  authCode: string;
  isSandbox: boolean;
  isOnboardingFastFetch?: boolean;
}

export interface ChildRelationshipObjectResponse {
  childRelationships: ChildRelationshipObject[];
}

export interface CrmOrgEmailTemplatesResponse {
  emailTemplates: CrmOrgEmailTemplate[];
}

export interface CrmOrgQueueResponse {
  queues: CrmOrgQueue[];
}

export interface CrmOrgQueue {
  id: string;
  name: string;
}

export interface CrmOrgObjectTypesResponse {
  objectTypes: ObjectTypeName[];
}

interface AiChatBasePayload {
  sessionId: string;
  message: string;
  isFirstMessage: boolean;
  crmOrgId: string;
}

export interface AiChatFieldPayload extends AiChatBasePayload {
  context: AiChatFieldContext;
}

export interface AiChatConfigurationPayload extends AiChatBasePayload {
  context: AiChatConfigurationContext;
}

type SFDCPicklistField = { name: string; label: string; values: SaltoPicklistValue[] };
export type SFDCLeadingField = SFDCPicklistField & { isLeadingCandidate: boolean };

export interface ObjectTypesArguments {
  orgId: string;
  createableObjectsOnly?: boolean;
  triggerableObjectsOnly?: boolean;
  updateableObjectsOnly?: boolean;
  queryableObjectsOnly?: boolean;
}

export type ShortFunnel = {
  id: string;
  name: string;
  description: string;
  funnelDetails: FunnelDetails;
  updatedAt: string;
  updatedById: string;
  isDeployed: boolean;
  apiName: string;
};

export type ShortParserRecordType = {
  label: string;
  name: string;
};

export type ParsedRecordTypesAndFunnels = {
  orgId: string;
  activeOnly: boolean;
  objectsData: ParsedRecordTypesAndFunnelsObjectData[];
};

export type ParsedRecordTypesAndFunnelsObjectData = {
  name: string; // object api name
  label: string; // object label
  recordTypes: ShortParserRecordType[];
  funnels: ShortFunnel[];
};

export interface SnowflakeCredentials {
  snowflakeAccountIdentifier: string;
  username: string;
  privateKey: string;
}

export interface SnowflakeDatabase {
  name: string;
}

export interface SnowflakeOrgCreateDto extends SnowflakeCredentials {
  database: string;
  name: string;
}
